import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { useSendCommand } from '@/_core/cqrs/use';
import { InitializeReleaseViewOrder, InitializeReleaseViewOrderResult } from '../../../api/commands/initializeReleaseViewOrder';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class InitializeReleaseViewOrderAction extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'InitializeReleaseViewOrder';

    public subtaskOrders: { [key: string]: number } = {};

    constructor(public releaseId: string) {
        super(InitializeReleaseViewOrderAction.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: InitializeReleaseViewOrderAction): Promise<boolean> => {
    // Check if ALL subtasks in this release have null releaseViewOrder
    const subtasksInRelease = state.subtasks.filter((s) => s.releaseId === action.releaseId);

    if (subtasksInRelease.length === 0) {
        return false; // No subtasks to initialize
    }

    const allNull = subtasksInRelease.every((s) => s.releaseViewOrder === null || s.releaseViewOrder === undefined);

    if (!allNull) {
        return false; // Some cards already have order, don't initialize
    }

    // Send command to backend
    const command = new InitializeReleaseViewOrder(state.id, action.releaseId);
    const result = await useSendCommand<InitializeReleaseViewOrderResult>(action, {
        createCommand: () => command,
        onSuccess: (res) => {
            if (res.WasInitialized && res.SubtaskOrders) {
                // Store the returned orders in the action for the reducer
                action.subtaskOrders = res.SubtaskOrders;
            }
        },
    });

    return result;
};

const reducer = (state: StorymapState, action: InitializeReleaseViewOrderAction): void => {
    // Update local state with initialized orders
    if (action.subtaskOrders) {
        Object.entries(action.subtaskOrders).forEach(([subtaskId, order]) => {
            const subtask = state.subtasks.find((s) => s.id === subtaskId);
            if (subtask) {
                subtask.releaseViewOrder = order;
            }
        });
    }
};

//@ts-ignore
registerMiddleware(InitializeReleaseViewOrderAction.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(InitializeReleaseViewOrderAction.ACTION_TYPE, reducer);
